import React, { useMemo } from 'react';

import { FormValues, IJSONSchema } from '../../integration-test-modal.types';

import { schemaFieldUtils } from './schema-form-field.utils';
import { SchemaFormField } from './SchemaFormField';

interface ISchemaFormProps {
  schema: IJSONSchema;
  values: FormValues;
  onValueChange: (path: string, value: unknown) => void;
  hideOptionalFields?: boolean;
}

export const SchemaForm: React.FC<ISchemaFormProps> = ({ schema, values, onValueChange, hideOptionalFields }) => {
  const requiredFields = useMemo(() => new Set(schema.required || []), [schema.required]);

  const propertyEntries = useMemo(() => {
    const entries = Object.entries(schema.properties);
    return entries.sort(([nameA, propertyA], [nameB, propertyB]) => {
      const aIsRequired = requiredFields.has(nameA);
      const bIsRequired = requiredFields.has(nameB);
      
      if (aIsRequired !== bIsRequired) {
        return aIsRequired ? -1 : 1;
      }
      
      const aIsNested = schemaFieldUtils.isNestedObjectField(propertyA);
      const bIsNested = schemaFieldUtils.isNestedObjectField(propertyB);
      
      if (aIsNested !== bIsNested) {
        return aIsNested ? 1 : -1;
      }
      
      return 0;
    });
  }, [schema.properties, requiredFields]);

  return (
    <div className="space-y-5">
      {propertyEntries.map(([propertyName, property]) => (
        <SchemaFormField
          key={propertyName}
          name={propertyName}
          path={propertyName}
          property={property}
          value={values[propertyName]}
          onChange={onValueChange}
          required={requiredFields.has(propertyName)}
          definitions={schema.definitions}
          hideOptionalFields={hideOptionalFields}
        />
      ))}
    </div>
  );
};
